import React, { useEffect } from "react";

import { useLogout } from "api/services/useAuth";
import { ErrorView } from "components/common/ErrorView";
import { ErrorType } from "components/common/ErrorView/types";
import { REACT_APP_LOGOUT_URL } from "config/config";
import { getPostLogoutRedirectUrl, replaceWindowLocation } from "utils/utilityFunctions";

export function LogOutRoute() {
  const { refetch: logout } = useLogout();

  useEffect(() => {
    // Clear Groundlight session cookies via Janzu, then redirect to the IdP logout URL.
    // For Axon SSO, janzu returns idp_logout_url (Axon /api/logout). Legacy Cognito/FusionAuth
    // keep using REACT_APP_LOGOUT_URL.
    logout().then((logoutResponse) => {
      replaceWindowLocation(getPostLogoutRedirectUrl(logoutResponse, REACT_APP_LOGOUT_URL));
    });
  }, [logout]);

  return <ErrorView error={ErrorType.LOGGED_OUT} />;
}
